const STORAGE_KEY = "adatis_health_prompt_dismiss";

type HealthPromptDismissMap = Record<string, string>;

const clientKey = (clientId: number): string => `c:${clientId}`;

const readMap = (): HealthPromptDismissMap => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }
    return parsed as HealthPromptDismissMap;
  } catch {
    return {};
  }
};

const writeMap = (map: HealthPromptDismissMap): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore quota / private mode
  }
};

/**
 * "Depois" after Chegou — skip health-record prompt for this client
 * on the same local calendar day (`dayKey` = YYYY-MM-DD). Paridade Expo ADJ-F1-248 #3.
 */
export const wasHealthPromptDismissedToday = (
  clientId: number,
  dayKey: string
): boolean => {
  if (!Number.isFinite(clientId) || !dayKey) {
    return false;
  }
  return readMap()[clientKey(clientId)] === dayKey;
};

export const dismissHealthPromptForDay = (
  clientId: number,
  dayKey: string
): void => {
  if (!Number.isFinite(clientId) || !dayKey) {
    return;
  }
  const map = readMap();
  map[clientKey(clientId)] = dayKey;
  writeMap(map);
};

/** Clears a "Depois" so the prompt can appear again the same day. */
export const clearHealthPromptDismiss = (clientId: number): void => {
  if (!Number.isFinite(clientId)) {
    return;
  }
  const map = readMap();
  const key = clientKey(clientId);
  if (!(key in map)) {
    return;
  }
  delete map[key];
  writeMap(map);
};
